import { render } from "./LoadingIcon.vue?vue&type=template&id=459fd2ae"
const script = {}

import "./LoadingIcon.vue?vue&type=style&index=0&id=459fd2ae&lang=css"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__